import {fetch} from "utils/dataAccess";

export async function getOrdersData(startDate, endDate, unit, retailer = null) {
    let url = `/dashboard/orders_data?startDate=${startDate}&endDate=${endDate}&unit=${unit}`;

    if (retailer) {
        url += `&retailer=${String(retailer).replace('/retailers/', '')}`;
    }

    const response = await fetch(url);

    return response.json();
}
